import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { IOptionProps } from '@components/option';
import { OptionList } from '@components/option-list';
import { Dropdown } from '@components/dropdown';
import { OptionListHeader } from '@components/option-list-header';
import { PopoutPlacement } from '@hooks';
import { WithChildrenCommonProps } from '@types';
export type IDropdownOption<T> = {
  label: string;
  leftContent?: JSX.Element;
  value: string;
} & T;
export type IDropdownOptionList = WithChildrenCommonProps<{
  /** Defines the width of the Dropdown element */
  dropdownWidth?: number | string;
  /** Indicates if the dropdown is opened */
  isOpen: boolean;
  /** Indicates the number of items to be displayed in the dropdown when it is opened */
  maxVisibleOptions?: number;
  /** Text to display in the header of the option list */
  optionsHeaderText?: string;
  /** Function to be executed when changing the selected value */
  onChange: (value: IDropdownOption<unknown>) => void;
  /** Function to be executed when clicking outside the dropdown */
  onClickAway: VoidFunction;
  /** Indicates the position of the dropdown relative to the TextField */
  placement?: PopoutPlacement;
  /** Reference of the element from which the dropdown is going to be shown */
  reference: HTMLElement | null;
}>;

/**
 * Renders a dropdown with a list of selectable options.
 * Expects only `Option` components (implementing `IOptionProps`) as children.
 * Non-element children are passed through unchanged.
 */
export const DropdownOptionList = t0 => {
  const $ = _c(32);
  let children;
  let dataId;
  let isOpen;
  let onChange;
  let onClickAway;
  let optionsHeaderText;
  let reference;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      children,
      dataId,
      isOpen,
      maxVisibleOptions: t1,
      optionsHeaderText,
      onChange,
      onClickAway,
      placement: t2,
      reference,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = dataId;
    $[3] = isOpen;
    $[4] = onChange;
    $[5] = onClickAway;
    $[6] = optionsHeaderText;
    $[7] = reference;
    $[8] = rest;
    $[9] = t1;
    $[10] = t2;
  } else {
    children = $[1];
    dataId = $[2];
    isOpen = $[3];
    onChange = $[4];
    onClickAway = $[5];
    optionsHeaderText = $[6];
    reference = $[7];
    rest = $[8];
    t1 = $[9];
    t2 = $[10];
  }
  const maxVisibleOptions = t1 === undefined ? 5 : t1;
  const placement = t2 === undefined ? "bottom-start" : t2;
  let t3;
  if ($[11] !== optionsHeaderText) {
    t3 = optionsHeaderText && <OptionListHeader>{optionsHeaderText}</OptionListHeader>;
    $[11] = optionsHeaderText;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== children || $[14] !== onChange || $[15] !== reference) {
    let t5;
    if ($[17] !== onChange || $[18] !== reference) {
      t5 = child => {
        if (!React.isValidElement(child)) {
          return child;
        }
        if (!("value" in child.props)) {
          return child;
        }
        return React.cloneElement(child, {
          onClick: (event, value) => {
            child.props.onClick?.(event, value);
            reference?.focus();
            onChange(value);
          }
        } as Partial<IOptionProps>);
      };
      $[17] = onChange;
      $[18] = reference;
      $[19] = t5;
    } else {
      t5 = $[19];
    }
    t4 = React.Children.toArray(children).map(t5);
    $[13] = children;
    $[14] = onChange;
    $[15] = reference;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  let t5;
  if ($[20] !== maxVisibleOptions || $[21] !== t4) {
    t5 = <OptionList maxVisibleOptions={maxVisibleOptions} addHalfOption={true}>{t4}</OptionList>;
    $[20] = maxVisibleOptions;
    $[21] = t4;
    $[22] = t5;
  } else {
    t5 = $[22];
  }
  let t6;
  if ($[23] !== dataId || $[24] !== isOpen || $[25] !== onClickAway || $[26] !== placement || $[27] !== reference || $[28] !== rest || $[29] !== t3 || $[30] !== t5) {
    t6 = <Dropdown data-id={dataId} isOpen={isOpen} onClickAway={onClickAway} placement={placement} reference={reference} {...rest}>{t3}{t5}</Dropdown>;
    $[23] = dataId;
    $[24] = isOpen;
    $[25] = onClickAway;
    $[26] = placement;
    $[27] = reference;
    $[28] = rest;
    $[29] = t3;
    $[30] = t5;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  return t6;
};